"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.getBackgroundStylesForSingleClass = exports.getStyleRules = exports.getStyleRulesForClassName = void 0;

var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _SimpleUtils = require("./SimpleUtils");

var getStyleRulesForClassName = function getStyleRulesForClassName(className) {
  var styleSheets = typeof window !== "undefined" ? window.document.styleSheets : [];

  for (var i = 0; i < styleSheets.length; i++) {
    var classes = void 0;

    try {
      classes = typeof styleSheets[i].rules !== 'undefined' ? styleSheets[i].rules : typeof styleSheets[i].cssRules !== 'undefined' ? styleSheets[i].cssRules : '';
    } catch (e) {}

    if (classes) {
      var _context;

      var foundClass = (0, _reduce.default)(_context = (0, _slice.default)(Array.prototype).call(classes)).call(_context, function (foundAcc, styleRule) {
        if (styleRule.selectorText === className) {
          foundAcc.push(styleRule);
        }

        return foundAcc;
      }, []);

      if (foundClass.length) {
        return foundClass;
      }
    }
  }

  return [];
};

exports.getStyleRulesForClassName = getStyleRulesForClassName;

var getStyleRules = function getStyleRules(cssStyleRules) {
  var _context2;

  var styles = {};

  if (cssStyleRules.length > 0 && typeof cssStyleRules[0].style !== 'undefined') {
    var constructorName = cssStyleRules[0].style.constructor.name || cssStyleRules[0].style.constructor.toString();

    switch (constructorName) {
      case 'CSS2Properties':
      case '[object MSStyleCSSProperties]':
        (0, _forEach.default)(_context2 = (0, _values.default)(cssStyleRules[0].style)).call(_context2, function (prop) {
          styles[(0, _SimpleUtils.toCamelCase)(prop)] = cssStyleRules[0].style[prop];
        });
        break;

      case 'CSSStyleDeclaration':
        styles = cssStyleRules[0].style;
        break;

      default:
        console.error('Unknown style object prototype');
        break;
    }
  }

  return styles;
};

exports.getStyleRules = getStyleRules;

var getBackgroundStylesForSingleClass = function getBackgroundStylesForSingleClass(className) {
  if (className && (0, _SimpleUtils.isString)(className)) {
    var cssStyleRules = getStyleRulesForClassName("." + className);

    if ((cssStyleRules === null || cssStyleRules === void 0 ? void 0 : cssStyleRules.length) > 0 && typeof cssStyleRules[0].style !== 'undefined') {
      var _context3, _context4;

      return (0, _reduce.default)(_context3 = (0, _filter.default)(_context4 = (0, _keys.default)(getStyleRules(cssStyleRules))).call(_context4, function (key) {
        return (0, _indexOf.default)(key).call(key, 'background') === 0 && cssStyleRules[0].style[key] !== '';
      })).call(_context3, function (newData, key) {
        newData[key] = cssStyleRules[0].style[key];
        return newData;
      }, {});
    }
  }

  return {};
};

exports.getBackgroundStylesForSingleClass = getBackgroundStylesForSingleClass;

var getBackgroundStyles = function getBackgroundStyles(className) {
  if (typeof window !== "undefined") {
    var classes = (0, _SimpleUtils.stringToArray)(className);

    if (classes instanceof Array) {
      var classObjects = [];
      (0, _forEach.default)(classes).call(classes, function (item) {
        return classObjects.push(getBackgroundStylesForSingleClass(item));
      });
      return _assign.default.apply(Object, classObjects);
    }

    return getBackgroundStylesForSingleClass(className);
  }

  return {};
};

var _default = getBackgroundStyles;
exports.default = _default;